import Logger from '@3vjia/v-logger';
import javascriptBridge from '@/core/lib/javascript-bridge';

// 百度统计
let baiduKey;
if (['test', 'prod'].includes(process.env.VUE_APP_ENV)) {
  baiduKey = [process.env.VUE_APP_BAIDU_KEY];
}

const logger = new Logger({
  websiteType: javascriptBridge.device.android ? 7 : 6,
  disableUploadEvent: true,
  env: process.env.VUE_APP_ENV,
  disablePageview: true,
  baiduKey,
});

export default logger;
